"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminImportDrivesController = /** @class */ (function () {
    function AdminImportDrivesController($state, $stateParams, FlashService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.FlashService = FlashService;
    }
    return AdminImportDrivesController;
}());
AdminImportDrivesController.$inject = [
    "$state",
    "$stateParams",
    "FlashService",
];
exports.default = AdminImportDrivesController;
